import React, { Fragment } from "react";
import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import ConstantList from "../appConfig";
import { useTranslation } from "react-i18next";
import { Home } from "@material-ui/icons";
import { Button, ButtonGroup } from "@material-ui/core";
import { useHistory  } from "react-router-dom";
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { TAB_LIST } from "app/PatientManagement/PatientGeneral/PatientGeneralIndex";
import { TAB_LIST_TREAMENTS } from "app/TreatmentManagement/TreamentInfoDetail/TreamentInfoDetailIndex";
const GlobitsBreadcrumb = ({ routeSegments }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const useStyles = makeStyles((theme) => ({
  root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: isMobile ? "column" : "row",
      width: "100%",
    },
    location: {
      display: "flex",
      fontSize: isMobile ? "12px" : "14px",
      flexWrap: "wrap",
      alignItems: "center",
      ...(isMobile && {
        textAlign: "right",
        flex: 1,
      }),
    },
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 4,
      ...(isMobile && {
        width: "100%",
        justifyContent: "space-between",
      }),
    },
    currentPage: {
      color: 'blue',
      fontWeight: 500,
    },
    active: {
      color: 'blue',
      fontWeight: 600,
      fontSize: '15px',
    },
  }));

  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const {
      tabHistory,
      goBackTab,
      tabNext,
      goForwardTab
    } = useStore().patientManagementStore.patientGeneralStore;
    const pathname = window.location.pathname;
    const isPatientTabPage = pathname.includes("patient-general");
    const isTreatmentTabPage = pathname.includes("treatment-patient-info-detail");

    const handleGoBack = () => {
      if (isPatientTabPage || isTreatmentTabPage) {
        if (tabHistory.length > 0) {
            goBackTab();
        } else {
          history.goBack();
        }
      } else {
        history.goBack();
      }
    };

    const handleGoForward = () => {
      if (isPatientTabPage || isTreatmentTabPage) {
        if (tabNext.length > 0) {
            goForwardTab();
        } else {
          history.goForward();
        }
      } else {
        history.goForward();
      }
    };

  return (
  <div className={classes.root}>
    {isMobile ? (
      <div className={classes.container}>
          <div
            onClick={handleGoBack}
            className="customs-button-navigate-mobile"
          >
            <NavigateBeforeIcon/>
          </div>

          <div
            onClick={handleGoForward}
            className="customs-button-navigate-mobile"
          >
            <NavigateNextIcon/>
          </div>
        <div className={classes.location}>
          <NavLink to={ConstantList.ROOT_PATH}>
            <span className="flex-center"><Home fontSize="small" /> {t("general.home")}</span>
          </NavLink>
          {routeSegments?.map((route, index) => (
            <Fragment key={index}>
              <span>&nbsp;/&nbsp;</span>
              <span className={index < routeSegments.length - 1 ? classes.currentPage : classes.active}>
                {route.name}
              </span>
              {route.subName && (
                <>
                  <span>&nbsp;/&nbsp;</span>
                  <span>{route.subName}</span>
                </>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    ) : (
      <>
        <div className={classes.location}>
          <NavLink to={ConstantList.ROOT_PATH}>
            <span className="flex-center"><Home fontSize="small" /> {t("general.home")}</span>
          </NavLink>
          {routeSegments?.map((route, index) => (
            <Fragment key={index}>
              <span>&nbsp;/&nbsp;</span>
              <span className={index < routeSegments.length - 1 ? classes.currentPage : classes.active}>
                {route.name}
              </span>
              {route.subName && (
                <>
                  <span>&nbsp;/&nbsp;</span>
                  <span>{route.subName}</span>
                </>
              )}
            </Fragment>
          ))}
        </div>
        <div className={classes.container}>
          <div
            onClick={handleGoBack}
            className="customs-button-navigate"
          >
            <NavigateBeforeIcon style={{ marginRight: 4 }} />
            Trang trước
          </div>

          <div
            onClick={handleGoForward}
            className="customs-button-navigate"
          >
            Trang sau
            <NavigateNextIcon style={{ marginLeft: 4 }} />
          </div>
        </div>
      </>
    )}
  </div>
  );

};

export default observer(GlobitsBreadcrumb);
